import { parser, lexer } from './grammar';
import createTSVisitor from './transpiler';
import createLinterVisitor from './linter';
export { suggest, tokens, parser, lexer, findTokenAtPos } from './grammar';
export { default as GreyCatLintError } from './lint-error';
const types = [];
const functions = [];
const GreyCatTypeScriptVisitor = createTSVisitor(parser);
const GreyCatLinterVisitor = createLinterVisitor(parser);
const transpiler = new GreyCatTypeScriptVisitor();
const linter = new GreyCatLinterVisitor();
export function parse(text) {
    const lexResult = lexer.tokenize(text);
    parser.input = lexResult.tokens;
    const cst = parser.greycat();
    return {
        cst,
        lexResult,
        parseErrors: parser.errors,
    };
}
export function transpile(cst) {
    return transpiler.visit(cst);
}
export function lint(cst, opts = { strict: true }) {
    return linter.visit(cst, Object.assign({}, opts, { typings: { types, functions } }));
}
export function addTypes(newTypes) {
    types.push(...newTypes);
}
export function addFunctions(newFunctions) {
    functions.push(...newFunctions);
}
export function clearTypes() {
    types.length = 0;
}
export function clearType(name) {
    types.splice(types.findIndex((t) => t.type === name), 1);
}
export function clearFunctions() {
    functions.length = 0;
}
export function clearFunction(name) {
    functions.splice(functions.findIndex((t) => t.name === name), 1);
}
//# sourceMappingURL=index.js.map